import * as Sentry from '@sentry/nextjs';
const mergeArgs = (args) => {
    if (!args)
        throw new Error('No arguments found');
    const message = args?.map((arg) => {
        if (typeof arg === 'object') {
            return JSON.stringify(arg);
        }
        return arg;
    }).join(' ');
    return message;
};
const logger = {
    error: (...args) => {
        const message = mergeArgs(args);
        console.error(message);
        Sentry.captureException(message);
    },
    warn: (...args) => {
        const message = mergeArgs(args);
        console.warn(message);
    },
    info: (...args) => {
        const message = mergeArgs(args);
        // eslint-disable-next-line no-console
        console.log(message);
        Sentry.captureMessage(message);
    },
};

export default logger;